import React, {useMemo} from 'react';
import {Box, Grid, List, ListItem, TextField} from '@mui/material';
import {KeyVaultRef} from "../../api/Model";
import {KeyLocationShield} from "../../components/location/KeyLocationShield";
import {inputChange, SetState} from "../../util/FormHandlers";
import {useVaultKeysStore} from "../../api/VaultKeysStore";
import {Loading} from "../../components/loading-data/LoadingData";

export type CollectKeyForm = {
    keyVault: KeyVaultRef;
    keyNumber?: string;
};

export function CollectUnknownKeyForm({form, setForm}: {
    form: CollectKeyForm,
    setForm: SetState<CollectKeyForm>,
}) {
    const vaultKeys = useVaultKeysStore(state => state.remoteValue);
    const currentKeyStates = useMemo(() => {
        return vaultKeys.map(currentKeys => currentKeys.byKeyNumber(form.keyNumber));
    }, [vaultKeys, form.keyNumber]);

    const onKeyNumberChange = inputChange(
        setForm,
        newValue => ({keyNumber: newValue || undefined}),
    );

    return (
        <Box sx={{minHeight: '10em'}}>
            <TextField
                required
                margin="dense"
                label="Key Number"
                fullWidth
                value={form.keyNumber || ''}
                onChange={onKeyNumberChange}
            />

            <Loading
                skeletonValue={[]}
                value={currentKeyStates}
            >{currentKeyStates => (
                <List>
                    {currentKeyStates.map(key => (
                        <ListItem key={`${key.key.id}-${key.historyRecord.id}`}>
                            <Grid container rowSpacing={1} columnSpacing={1} alignItems="baseline">
                                <Grid><KeyLocationShield location={key.historyRecord.location}/></Grid>
                                <Grid>from {key.historyRecord.vault.name}</Grid>
                                {key.historyRecord.from && <Grid>since {key.historyRecord.from}</Grid>}
                                {key.historyRecord.notes && <Grid size={12}>{key.historyRecord.notes}</Grid>}
                            </Grid>
                        </ListItem>
                    ))}
                </List>
            )}</Loading>
        </Box>
    );
}
